import React from "react";
import { Checkbox } from "@/components/Calendar/ui/checkbox";

interface RoomFilterProps {
  selectedRooms: string[];
  onRoomChange: (room: string, checked: boolean) => void;
  onSelectAll: (checked: boolean) => void;
  roomNames: string[]; // Accept as prop instead of importing
  isDarkMode?: boolean;
}

export function RoomFilter({
  selectedRooms,
  onRoomChange,
  onSelectAll,
  roomNames = [],
  isDarkMode = false,
}: RoomFilterProps) {
  return (
    <div
      className={`rounded-lg border p-4 transition-colors duration-300 ${
        isDarkMode ? "bg-gray-700 border-gray-600" : "bg-white border-gray-200"
      }`}
    >
      <h4
        className={`text-sm font-semibold mb-3 transition-colors duration-300 ${
          isDarkMode ? "text-white" : "text-gray-900"
        }`}
      >
        Room
      </h4>
      <div className="space-y-3">
        <div className="flex items-center space-x-2">
          <Checkbox
            id="select-all-rooms"
            checked={selectedRooms.length === roomNames.length}
            onCheckedChange={onSelectAll}
          />
          <label
            htmlFor="select-all-rooms"
            className={`text-sm cursor-pointer transition-colors duration-300 ${
              isDarkMode ? "text-gray-400" : "text-gray-500"
            }`}
          >
            Select All
          </label>
        </div>
        <hr
          className={`transition-colors duration-300 ${
            isDarkMode ? "border-gray-600" : "border-gray-200"
          }`}
        />
        {roomNames.map((room) => (
          <div key={room} className="flex items-center space-x-2">
            <Checkbox
              id={`room-${room}`}
              checked={selectedRooms.includes(room)}
              onCheckedChange={(checked) => onRoomChange(room, !!checked)}
            />
            <label
              htmlFor={`room-${room}`}
              className={`text-sm cursor-pointer transition-colors duration-300 ${
                isDarkMode ? "text-gray-300" : "text-gray-700"
              }`}
            >
              {room}
            </label>
          </div>
        ))}
      </div>
    </div>
  );
}
